<template>
 <div class="w_content">
		<div class="women">
			<a href="#"><h4> </h4></a>
		
		     <div class="clearfix"></div>	
		</div>
        
        
		<!-- grids_of_4 -->
		<div class="grids_of_4">
		 
			<div class="clearfix"></div>
		</div>
		<div class="grids_of_4">
		 
			<div class="clearfix"></div>
		</div>
		<div class="grids_of_4">
		  
			<div class="clearfix"></div>
            
            
            
            
		</div>
		
        
        	<div class="grids_of_4">
		  
			<div class="clearfix"></div>
            
            
            
            
		</div>
		
		
		
		<!-- end grids_of_4 -->
		
		
	</div>
</template>

<script>
export default {
  name: 'proxy',
 props:
 {
     searchString: 
    {
     type: String,
      required: true
  }
 },
data()
{
    return {
        searchValue: "",
        searchResults: []
    }
},
mounted()
{
    this.searchValue = this.searchString;
    this.$router.push(`/timeawards/searchPage/${this.searchValue}`);
},
methods:
{
    searchGraphql: async function()
    {
        //fire axios graphQl query using props
        //this.searchString
    },
    
	viewProfile: function(profileId)
	{
		this.$router.push(`/timeawards/profileView/awardee/${profileId}`);
	}
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
